import axios from 'CanExConfig/axios'

const endpoint = candidateProfileId => `/api/candidate/profiles/${candidateProfileId}`

export const getCandidateProfile = async candidateProfileId => {
  const response = await axios(endpoint(candidateProfileId), {
    method: 'GET',
  })

  return response.data
}

export const patchCandidateProfile = async (candidateProfileId, data) => {
  const response = await axios(endpoint(candidateProfileId), {
    method: 'PATCH',
    data,
  })

  return response.data
}
